namespace TabAurous.OMS {
    export interface RewardsDetailsRow {
        RDetailsId?: number;
        RMasterId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        PurchaseValue?: number;
        PurchasePoints?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
    }

    export namespace RewardsDetailsRow {
        export const idProperty = 'RDetailsId';
        export const localTextPrefix = 'OMS.RewardsDetails';
        export const deletePermission = 'Masters:Rewards:Delete';
        export const insertPermission = 'Masters:Rewards:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:Rewards:Edit';

        export declare const enum Fields {
            RDetailsId = "RDetailsId",
            RMasterId = "RMasterId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            PurchaseValue = "PurchaseValue",
            PurchasePoints = "PurchasePoints",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName"
        }
    }
}
